export default {
  quiz: {},
  quizzes: [],
  time: null
};
